// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import MoneyBackGuarantee20 from './MoneyBackGuarantee20.tsx';
import MoneyBackGuarantee20Filled from './MoneyBackGuarantee20Filled.tsx';
import MoneyBackGuarantee20Circle from './MoneyBackGuarantee20Circle.tsx';
import MoneyBackGuarantee24 from './MoneyBackGuarantee24.tsx';
import MoneyBackGuarantee24Filled from './MoneyBackGuarantee24Filled.tsx';
import MoneyBackGuarantee24Circle from './MoneyBackGuarantee24Circle.tsx';
import MoneyBackGuarantee40 from './MoneyBackGuarantee40.tsx';
import MoneyBackGuarantee40Filled from './MoneyBackGuarantee40Filled.tsx';
import MoneyBackGuarantee48 from './MoneyBackGuarantee48.tsx';
import MoneyBackGuarantee48Filled from './MoneyBackGuarantee48Filled.tsx';

type MoneyBackGuaranteeProps = {
    variation:
        | '20'
        | '20Filled'
        | '20Circle'
        | '24'
        | '24Filled'
        | '24Circle'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    MoneyBackGuarantee20,
    MoneyBackGuarantee20Filled,
    MoneyBackGuarantee20Circle,
    MoneyBackGuarantee24,
    MoneyBackGuarantee24Filled,
    MoneyBackGuarantee24Circle,
    MoneyBackGuarantee40,
    MoneyBackGuarantee40Filled,
    MoneyBackGuarantee48,
    MoneyBackGuarantee48Filled,
};

const MoneyBackGuarantee: FC<MoneyBackGuaranteeProps> = ({ variation, ...props }) => {
    const variationKey = `MoneyBackGuarantee${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"MoneyBackGuarantee" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default MoneyBackGuarantee;
